module.exports = __webpack_public_path__ + "static/media/graph.0c022920.png";